<script>
/* eslint-disable */
//import { mapGetters } from "vuex"
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";
const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};
export default {
  data() {
    return {
      timerOnScreenOptions: [
        { value: "yes", text: "Yes" },
        { value: "no", text: "No" },
      ],
      showSelectAll: true,
      _notes: "",
    };
  },
  components: {
    Multiselect,
  },
  mounted() {
    // this.$store.dispatch(
    //   `${this.currentType}/getActivity`,
    //   this.currentActivity.id
    // );
  },
  methods: {
    saveNotes(e) {
      this.$store.dispatch(`${this.currentType}/setActivityField`, {
        fieldName: "notes",
        value: e.target.value,
      });
    },
  },
  computed: {
    levelOptions() {
      return this.$store.getters[`${this.currentType}/levelOptions`];
    },

    emotionsOptions() {
      if (this.currentType === "stretchflows") {
        return this.$store.getters[`${this.currentType}/sfEmotionOptions`];
      } else {
        return this.$store.getters[`${this.currentType}/emotionsOptions`];
      }
    },
    emotionsOptionsRemapped() {
      var emotions = [];
      this.emotionsOptions.map((option) => {
        if (option.value != null && option.value != "") {
          emotions.push(option);
        }
      });
      return emotions;
    },

    intensityOptions() {
      if (this.currentType === "stretchflows") {
        return this.$store.getters[`${this.currentType}/sfIntensityOptions`];
      } else {
        return this.$store.getters[`${this.currentType}/intensityOptions`];
      }
    },
    intensityOptionsRemapped() {
      var intensity = [];
      this.intensityOptions.map((option) => {
        if (option.value != null && option.value != "") {
          intensity.push(option);
        }
      });
      return intensity;
    },

    locationsOptions() {
      return this.$store.getters[`${this.currentType}/locationsOptions`];
    },
    locationsOptionsRemapped() {
      var locations = [];
      this.locationsOptions.map((option) => {
        if (option.value != null && option.value != "") {
          locations.push(option);
        }
      });
      return locations;
    },

    currentActivity() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          return "stretchflows";
        } else if (
          url == "update-workout" ||
          this.$route.path == "/create-workout"
        ) {
          return "workouts";
        }
      }
      return "commons";
    },
    levels: {
      set(value) {
        this.$store.dispatch(`${this.currentType}/setActivityField`, {
          fieldName: "levels",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.levels;
        }
        return [];
      },
    },
    levelOptionsRemapped() {
      return this.levelOptions.map((levelOption) => levelOption.text);
    },
    emotion: {
      set(value) {
        this.$store.dispatch(`${this.currentType}/setActivityField`, {
          fieldName: "emotion",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.emotion;
        }
        return "";
      },
    },
    intensity: {
      set(value) {
        this.$store.dispatch(`${this.currentType}/setActivityField`, {
          fieldName: "intensity",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.intensity;
        }
        return "";
      },
    },
    notes: {
      set(value) {
        this._notes = value;
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.notes;
        }
        return "";
      },
    },

    location: {
      set(value) {
        this.$store.dispatch(`${this.currentType}/setActivityField`, {
          fieldName: "location",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.location;
        }
        return "";
      },
    },
    timer_on_screen: {
      set(value) {
        this.$store.dispatch(`${this.currentType}/setActivityField`, {
          fieldName: "timer_on_screen",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.timer_on_screen;
        }
        return "";
      },
    },
  },
};
</script>

<style scoped>
.toolbar {
  padding: 8px 18px;
  background-color: #efefef;
  color: #000;
}
label {
  text-transform: uppercase;
  color: #000;
}
</style>

<template>
  <div class="w-100">
    <div class="row toolbar">
      <div class="col-md-5">
        <div class="row">
          <div class="col-md-6 level-dropdown">
            <label>Level</label>
            <multiselect
              v-model="levels"
              :options="levelOptionsRemapped"
              mode="tags"
            ></multiselect>
          </div>
          <div class="col-md-3">
            <label>Emotion</label>
            <b-form-select
              v-model="emotion"
              :options="emotionsOptionsRemapped"
            ></b-form-select>
          </div>
          <div class="col-md-3">
            <label>Intensity</label>
            <b-form-select
              v-model="intensity"
              :options="intensityOptionsRemapped"
            ></b-form-select>
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <div class="row">
          <div class="col-md-7">
            <label>Notes</label>
            <b-form-input @blur="saveNotes" v-model="notes"></b-form-input>
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-md-6">
                <label>Location</label>
                <b-form-select
                  v-model="location"
                  :options="locationsOptionsRemapped"
                ></b-form-select>
              </div>
              <div class="col-md-6">
                <label>Timer on Screen</label>
                <b-form-select
                  v-model="timer_on_screen"
                  :options="timerOnScreenOptions"
                ></b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>